import { Button } from '@shopify/polaris';
import { ViewIcon } from '@shopify/polaris-icons';
import CustomBadge from '#client/components/common/CustomBadge/CustomBadge';
import axios from 'axios';
import { queryClient } from '#client/utils/queryClient';

const format = {
    date: (date) => new Date(date).toLocaleDateString('en-US'),
};

const InventoryAdjustmentTableConfig = {
    objectName: 'InventoryAdjustment',
    resourceName: {
        singular: 'Inventory Adjustment',
        plural: 'Inventory Adjustments',
    },
    resourceURL: '/api/app/inventory-adjustments',
    reloadOnLocationChange: true,
    columns: [
        {
            key: 'name',
            title: 'Adjustment ID',
            type: 'text',
            isSortable: true,
            isFilterable: true,
            isViewable: true,
        },
        {
            key: 'description',
            title: 'Description',
            type: 'text',
            isSortable: true,
            isFilterable: true,
            isViewable: true,
        },
        {
            key: 'reasonCode.reasonCode',
            title: 'Reason Code',
            type: 'text',
            isSortable: false,
            isFilterable: true,
            isViewable: false,
            filterOptions: async function () {
                const response = await queryClient.fetchQuery({
                    queryKey: ['inventory-adjustment-reason-codes'],
                    queryFn: async () => {
                        const res = await axios.get(`${import.meta.env.VITE_API_URL}/api/app/inventory-adjustments/reason-codes`);
                        return res.data.data.reasonCodes;
                    },
                    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
                });
                return response.map((rc) => ({
                    title: rc.reasonCode,
                    value: rc.reasonCode,
                }));
            },
            filterType: 'multiselect',
        },
        {
            key: 'reasonCode.reasonCode',
            title: 'Reason Code',
            type: 'text',
            isSortable: true,
            isFilterable: false,
            isViewable: true,
            accessor: (value, row) => row.reasonCode?.reasonCode,
        },
        {
            key: 'location.name',
            title: 'Store',
            type: 'text',
            isSortable: true,
            isFilterable: true,
            isViewable: true,
            locationFilterOptions: true,
            filterOptions: async function () {
                const response = await queryClient.fetchQuery({
                    queryKey: ['admin-locations'],
                    queryFn: async () => {
                        const res = await axios.get(`${import.meta.env.VITE_API_URL}/api/app/admin/locations`);
                        return res.data.data.locations;
                    },
                });
                return response.map((loc) => ({
                    title: loc.name,
                    value: loc.name,
                }));
            },
            filterType: 'multiselect',
        },
        {
            key: 'createdAt',
            title: 'Created Date',
            type: 'date',
            isSortable: true,
            isFilterable: true,
            isViewable: true,
            defaultSortDirection: 'desc',
            accessor: format.date,
        },
        {
            key: 'netQty',
            title: 'Net Qty',
            type: 'number',
            isSortable: false,
            isFilterable: false,
            isViewable: true,
            accessor: (value) => value,
        },
        {
            key: 'status',
            title: 'Status',
            type: 'text',
            isSortable: true,
            isFilterable: true,
            filterOptions: [
                { title: 'Draft', value: 'Draft' },
                { title: 'Completed', value: 'Completed' },
            ],
            filterType: 'checkbox',
            isViewable: true,
            accessor: (status, row) => <CustomBadge key={`badge-${row.id}`} status={row.status} />,
        },
        {
            key: 'actions',
            title: 'Actions',
            type: 'text',
            isSortable: false,
            isFilterable: false,
            isViewable: true,
            accessor: (value, row, navigate) => <Button icon={ViewIcon} variant="plain" onClick={() => navigate(`/inventory-adjustments/${row.id}`)}></Button>,
        },
    ],
};

export default InventoryAdjustmentTableConfig;
